export default __webpack_public_path__ + "hero-subtitle.f4afc74.png";